import type { OnboardingStep } from "../../lib/onboarding";

interface Props {
  step: OnboardingStep;
  onBack: () => void;
  onNext: () => void;
  isLast: boolean;
}

const LABELS: Record<OnboardingStep, string> = {
  welcome: "Welcome",
  permissions: "Permissions",
  connect: "Connect your AI",
  device: "Name this device",
  pairing: "Pair with a client",
  complete: "You are set"
};

export function PlaceholderStep({ step, onBack, onNext, isLast }: Props) {
  return (
    <div className="py-12">
      <p className="display-eyebrow text-primary mb-6">
        {LABELS[step]}
      </p>

      <h1 className="display-hero text-[48px] sm:text-[56px] text-foreground mb-6">
        Coming <span className="text-primary">next</span>.
      </h1>

      <p className="text-[17px] leading-[1.55] text-ink2 max-w-[500px] mb-10 font-normal">
        This step is not designed yet. Walk the rest of the flow with the
        buttons below. Real design lands in a follow-up PR.
      </p>

      <div className="flex items-center gap-3">
        <button
          onClick={onBack}
          className="group inline-flex items-center gap-2 bg-transparent text-foreground border border-border pl-4 pr-5 py-3 rounded-lg font-medium text-[14px] hover:border-ink3 hover:bg-secondary/50 transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="w-3.5 h-3.5 transition-transform group-hover:-translate-x-0.5" aria-hidden="true">
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
          Back
        </button>
        <button
          onClick={onNext}
          className="group inline-flex items-center gap-2.5 bg-primary text-primary-foreground pl-6 pr-5 py-3 rounded-lg font-medium text-[14px] shadow-[0_1px_2px_rgba(0,71,255,0.15),0_4px_16px_-4px_rgba(0,71,255,0.35)] hover:shadow-[0_2px_4px_rgba(0,71,255,0.2),0_8px_24px_-4px_rgba(0,71,255,0.45)] hover:bg-primary/95 transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
        >
          {isLast ? "Start over" : "Next"}
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" aria-hidden="true">
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </button>
      </div>
    </div>
  );
}
